import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DesignerRequestVerb,
  ISetFileContentRequest,
  ISetFileContentResponse,
} from '@qodly/shared';
import { IWebFormStyleClass } from '@qodly/shared';
import { API_PREFIX, http, queue } from '@qodly/shared';
import { getCachedState } from '~store/utils';
import { fetchSharedCss } from './thunks';

export type ISharedCSSState = {
  state: 'loading' | 'loaded' | 'error';
  styles: IWebFormStyleClass[];
  error?: string;
};

const stylesQueue = queue();

async function setStyles(classes: IWebFormStyleClass[]) {
  const payload: ISetFileContentRequest = {
    verb: DesignerRequestVerb.SET_FILE_CONTENT,
    asText: false,
    name: 'shared_css.json',
    path: '',
    root: 'shared',
    content: {
      classes: classes.map(({ scope, ...cssClass }) => ({
        ...cssClass,
      })),
    },
  };

  await stylesQueue(() =>
    http<ISetFileContentResponse>(API_PREFIX, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    }),
  );
}

const stateSlice = createSlice({
  name: 'shared-css',
  initialState: (): ISharedCSSState => {
    const { sharedCSS } = getCachedState();

    return (
      sharedCSS || {
        state: 'loading',
        styles: [],
      }
    );
  },
  reducers: {
    updateSharedCss: (
      state,
      action: PayloadAction<{ classes: IWebFormStyleClass[] }>,
    ) => {
      state.styles = action.payload.classes;

      setStyles(action.payload.classes);

      return state;
    },
    initSharedCss: (
      state,
      action: PayloadAction<{ classes: IWebFormStyleClass[] }>,
    ) => {
      state.styles = action.payload.classes;

      return state;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSharedCss.pending, (state) => {
        return {
          ...state,
          state: 'loading',
          // styles: [],
        };
      })
      .addCase(fetchSharedCss.fulfilled, (_state, { payload }) => {
        return {
          state: 'loaded',
          styles: payload,
        };
      })
      .addCase(fetchSharedCss.rejected, (state, action) => {
        return {
          ...state,
          state: 'error',
          // styles: [],
          error: action.payload || 'Error while loading the shared css',
        };
      });
  },
});

export const { updateSharedCss, initSharedCss } = stateSlice.actions;

export default stateSlice;
